module.exports = __webpack_public_path__ + "img/delfin80.2afe2ff0.jpg";